







































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox} from 'simpli-web-sdk'
import {ITipoClienteResourcesHolder} from '@/interfaces/resource/ITipoClienteResourcesHolder'
import {TipoCliente as TipoClienteEnum} from '@/enums/TipoCliente'
import {TipoCliente} from '@/model/resource/TipoCliente'

@Component({
  components: {InputText, InputCheckbox},
})
export default class InputTipoCliente extends Vue {
  @Prop({type: Object, required: true})
  resourceHolder!: ITipoClienteResourcesHolder
  @Prop({type: Object, required: true}) model!: TipoCliente
  @Prop({type: String, default: null}) optionValue!: string | null

  TipoCliente = TipoClienteEnum

  async created() {
    if (!this.computedModel) {
      this.computedModel = new TipoCliente()
      this.computedModel.idTipoClientePk = TipoClienteEnum.Cliente
    }

    if (this.computedModel.idTipoClientePk === 0) {
      this.computedModel.idTipoClientePk = TipoClienteEnum.Cliente
    }

    await this.resourceHolder.collectionTipoCliente.queryAsPage()
  }

  get computedModel() {
    return this.model
  }

  set computedModel(val: TipoCliente) {
    this.$emit('input', val)
  }

  get option() {
    return this.optionValue
  }

  set option(val: string | number | null) {
    this.$emit('updateOption', val)
  }

  isTipoClienteChecked(tipoCliente: TipoCliente) {
    return this.computedModel.idTipoClientePk == tipoCliente.idTipoClientePk
  }

  checkTipoCliente(tipoCliente: TipoCliente) {
    this.computedModel = tipoCliente
  }
}
